import { Formik, FormikProps, FormikValues } from 'formik';
import * as React from 'react';

import { BasicFormProps } from './BasicForm.types';

const BasicForm: React.StatelessComponent<BasicFormProps> = ({ ...props }: BasicFormProps): JSX.Element => {
  const { initialValues, validation, onSubmit, children } = props;

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validation}
      onSubmit={onSubmit}
      render={({ errors }: FormikProps<FormikValues>) => children}
    />
  );
};

export { BasicForm as default };
